<script setup lang="ts">
import { SvgIcon } from "@progress/kendo-vue-common";
import { starIcon, starOutlineIcon } from '@progress/kendo-svg-icons'
import { useLogger } from 'vue-logger-plugin'
import { setStoreLogger } from '@/logger.ts'
import { ref, onMounted } from 'vue'
import type { IAoeProductReviewRatingSummary } from '@/types/ProductReviewTypes'
import { GetProductReviewsFromLocalStorageOrApi } from '@/services/ProductService'


const logger = useLogger()
setStoreLogger(logger)
logger.debug('AoeProductReviewList.vue')

const props = defineProps<{
  productcode: string
  showtotal?: boolean
  usecolor?: boolean
  starsize: string
}>()

const ratingSummary = ref<IAoeProductReviewRatingSummary | null>(null)
const total = ref<number>(0)

onMounted(async () => {
  logger.debug('onMounted productReviewStars')

  GetProductReviewsFromLocalStorageOrApi(props.productcode).then((prodReviewResp) => {
    if (prodReviewResp == null) {
      return
    }

    ratingSummary.value = prodReviewResp?.ratingsSummary
    total.value = prodReviewResp?.ratingsSummary?.total ?? 0
  })
})

</script>

<template>
    <div v-if="props.showtotal" class="ratingsTotalDiv">
      <div class="ratingsSummaryCell ratingsSummaryStars" v-for="i in 5" :key="i">
        <SvgIcon  v-if="i <= (Math.ceil(ratingSummary?.average ?? 0))" :icon="starIcon" :size="props.starsize"
          :class="i > (ratingSummary?.average ?? 0) ?  props.usecolor == true ? 'starColorPartial' : 'starNoColorPartial' : props.usecolor == true ?  'starColor' : 'starNoColor'"
          :style="i > (ratingSummary?.average ?? 0) ? 'clip-path: inset(0 ' + (Math.ceil(ratingSummary?.average ?? 0) - (ratingSummary?.average ?? 0)) * 100 + '% 0 0);' : ''"/>
        <SvgIcon  v-if="i > (ratingSummary?.average ?? 0)"  :icon="starOutlineIcon" :size="props.starsize"
          :class="i <= (Math.ceil(ratingSummary?.average ?? 0)) ? props.usecolor == true ? 'starMediumColorTop' : 'starMediumNoColorTop' : props.usecolor == true ? 'starColor' : 'starNoColor'"/>
      </div>
      <div class="ratingsSummaryCell ratingsSummaryStars ratingsSummaryTotal" v-text="`(${ratingSummary?.total ?? 0})`">
      </div>
    </div>
    <div v-else class="ratingsNoTotalDiv">
      <div class="ratingsSummaryStars" v-for="i in 5" :key="i">
        <SvgIcon  v-if="i <= (Math.ceil(ratingSummary?.average ?? 0))" :icon="starIcon" :size="props.starsize"
          :class="i > (ratingSummary?.average ?? 0) ?  props.usecolor == true ? 'starColorPartial' : 'starNoColorPartial' : props.usecolor == true ?  'starColor' : 'starNoColor'"
          :style="i > (ratingSummary?.average ?? 0) ? 'clip-path: inset(0 ' + (Math.ceil(ratingSummary?.average ?? 0) - (ratingSummary?.average ?? 0)) * 100 + '% 0 0);' : ''"/>
        <SvgIcon  v-if="i > (ratingSummary?.average ?? 0)"  :icon="starOutlineIcon" :size="props.starsize"
          :class="i <= (Math.ceil(ratingSummary?.average ?? 0)) ? props.usecolor == true ? 'starColorTop' : 'starNoColorTop' : props.usecolor == true ? 'starColor' : 'starNoColor'"/>
      </div>
    </div>
</template>

<style lang="scss">

.ratingsNoTotalDiv {
  white-space: nowrap;
}

.ratingsTotalDiv{
  display: table;
  -webkit-column-count: 6; /* Chrome, Safari, Opera */
  -moz-column-count: 6; /* Firefox */
  column-count: 6;
  height: 30px;
}

.ratingsSummaryCell
{
  display: table-cell;
  align-content: center;
}

.ratingsSummaryTotal
{
  @include typography-body;
  padding-left: 5px;
  color: #7e7e7e;
}

.starColor {
  color: #ffaa45;
}

.ratingsSummaryStars
{
  display: inline;
  width: 20px;
  position: relative;
}

.starColorPartial
{
  color: #ffaa45;
}

.starNoColorPartial
{
}

.starColorTop {
  position: absolute;
  left: 0px;
  top: 0px;
  color: #ffaa45;
 }

 .starNoColorTop {
  position: absolute;
  left: 0px;
  top: 0px;
}

.starMediumColorTop {
  position: absolute;
  left: 0px;
  top: 0px;
  color: #ffaa45;
 }

 .starMediumNoColorTop {
  position: absolute;
  left: 0px;
  top: 0px;
}

/* !important required: Prevent star icons from becoming huge when printing */
@media print {
  .ratingsSummaryStars .k-svg-icon,
  .ratingsSummaryStars svg {
    max-width: 20px !important;
    max-height: 20px !important;
    width: 20px !important;
    height: 20px !important;
  }
}
</style>
